const e = "provider-schedule-calendar-", r = {
    root: {
        view: `${e}-root-view`,
        header: `${e}-root-header`
    },
    calendar: {
        view: `${e}-calendar-view`
    }
};

export { r as default };
//# sourceMappingURL=test-ids.js.map
